export const gr = {
  languages: {
    english: "Αγγλικά",
    spanish: "Ισπανικά",
    dutch: "Ολλανδικά",
    french: "Γαλλικά",
    portuguese: "Πορτογαλικά",
    italian: "Ιταλικά",
    german: "Γερμανικά",
    polish: "Πολωνικά",
    romanian: "Ρουμανικά",
    greek: "Ελληνικά",
    //TODO: add new language here
  },
  loginPage: {
    title: "Σύνδεση",
    email: "Email",
    placeholder: "Εισαγάγετε το email σας",
    buttonText: "Σύνδεση",
    loginMessage:
      "Ένα email έχει σταλεί στη διεύθυνση email που δώσατε. Παρακαλώ κάντε κλικ στον σύνδεσμο στο email για να γίνει η ταυτοποίηση.",
    noEmailMessage:
      "Παρακαλώ χρησιμοποιήστε τον σύνδεσμο στο email που σας στάλθηκε για να ξεκινήσετε αυτή τη διαδικασία.",
  },
  formPage: {
    title: "Περιοδική Αναθεώρηση",
    submittedMessage: "Η φόρμα έχει υποβληθεί!",
    alreadySubmittedMessage:
      "Η φόρma έχει ήδη υποβληθεί! Αν θέλετε να αλλάξετε πληροφορίες που υποβλήθηκαν προηγουμένως, παρακαλούμε επικοινωνήστε με τον διαχειριστή της σχέσης σας.",
    waitMessage: "Φόρτωση δεδομένων, παρακαλώ περιμένετε...",
    asteriskMessage1: "Παρακαλώ συμπληρώστε όλα τα πεδία με",
    asteriskMessage2: "καθώς είναι υποχρεωτικά.",
    savedLocallyMessage:
      "Όλες οι αλλαγές θα αποθηκευτούν τοπικά στη συσκευή σας.",
    accessFormAgain: "Μπορείτε να αποκτήσετε ξανά πρόσβαση στη φόρμα χρησιμοποιώντας τον σύνδεσμο",
    openPRs: "Ανοικτές Περιοδικές Αναθεωρήσεις",
    addRelation: "Προσθήκη Σχέσης",
    submit: "Υποβολή",
    continue: "Συνέχεια",
    addFile: "Προσθήκη Αρχείου",
  },
};
